import React from 'react';
import PricingPage from 'components/pricing/PricingPage';

const Pricing = () => {
  return <PricingPage />;
};

Pricing.getInitialProps = async () => ({
  namespacesRequired: ['pricing'],
});

export default Pricing;
